import React, { useEffect, useRef } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../css/mission.css';



function Home() {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);
    const underlineRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (underlineRef.current) {
                underlineRef.current.classList.add('animate');
            }
        }, 50); // Delay before animation starts

        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            <div className="container-fluid about-bg2 d-flex align-items-end" style={{ padding: 0    , top: '-122px'}}>
                <div className="container-fluid about-content">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1 col-md-12">
                            <div className="d-flex flex-column flex-md-row align-items-start justify-content-between gap-4">

                                {/* العناوين والخط */}
                                <div style={{ minWidth: '300px', flexShrink: 0 }} className="text-md-start text-center">
                                    <h1 className="about-title">Our Mission & Vision</h1>
                                    <h2 className="about-subtitle">Petrochoice Integrated Services</h2>
                                    <div className="about-underline" ref={underlineRef}></div>
                                </div>

                                {/* الوصف النصي */}
                                <div style={{ flex: 1 }} className="text-md-end text-center">
                                    <p className="about-desc" style={{ fontSize: 18,textAlign: "justify" }}>
                                        Petrochoice is an internationally renowned corporation that specializes in delivering outstanding
                                        services to the oil and gas sector on a global scale. Leveraging our substantial knowledge and robust
                                        infrastructure, our unwavering commitment is to consistently achieve excellence across all facets of
                                        our operations.
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>






            {/* Section 2: About Block */}
            <div className="container my-5">
                <div className="row align-items-center">
                    <div className="col-lg-4 col-md-6 col-12 mb-4 mb-lg-0" data-aos="fade-up">

                        <img
                            src="/assets/mission.jpg"
                            alt="Rig Offshore"
                            className="img-fluid rounded mt-3"
                            data-aos="zoom-in"
                            data-aos-delay="200"
                        />
                    </div>
                    <div className="col-lg-6 col-md-6 col-12 mt-3 mt-md-0" data-aos="fade-left">
                        <h2 className="title">Our Vision</h2>
                        <p className='breif-aboutus' style={{ fontSize: 18, lineHeight: 1.7,textAlign: "justify" }}>
                            Our vision revolves around providing distinctive, cost-efficient solutions that empower organizations to thrive in a complex business landscape. We aim to be trusted partners, working hand in hand with our clients, combining our expertise to achieve international success.
                        </p>
                        <p className='breif-aboutus' style={{ fontSize: 18, lineHeight: 1.7, textAlign: "justify" }}>
                            Dedicated to achieving excellence, we confront challenges with determination, harnessing industry insights, innovative approaches, and a global network. Petrochoice is committed to redefining industry benchmarks, fostering mutual growth through integrity and exceptional outcomes.                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;